import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { grey } from "@mui/material/colors";
import { isFunction } from "lodash";
import React, { useCallback, useMemo } from "react";

const ExpandCollapseIconButton = ({
  active,
  onClick,
  activeIcon = <KeyboardArrowUp />,
  collapsedIcon = <KeyboardArrowDown />,
}) => {
  const handleOnClick = useCallback(
    (s) => {
      if (isFunction(onClick)) {
        onClick((s) => !s);
      }
    },
    [onClick],
  );

  const styles = useMemo(() => {
    return {
      background: active && isFunction(onClick) ? grey[100] : "none",
      "&:hover": { background: isFunction(onClick) ? grey[200] : "none" },
    };
  }, [active, onClick]);
  return (
    <IconButton onClick={handleOnClick} size="small" sx={styles}>
      {active ? activeIcon : collapsedIcon}
    </IconButton>
  );
};

export default ExpandCollapseIconButton;
